enum FPCustomEvents {
  stepUpCompleted = 'stepUpCompleted',
  receivedDeviceResponseJson = 'receivedDeviceResponseJson',
}

export default FPCustomEvents;
